import { createAction } from 'actions/utils';
import { createActionWithPayload } from 'actions/utils';

export const ACTIONS = {
  SET_AV_SESSION_TOKEN_LOADING: 'SET_AV_SESSION_TOKEN_LOADING',
  SET_AV_SESSION_TOKEN: 'SET_AV_SESSION_TOKEN',
  RESET_AV_SESSION_TOKEN: 'RESET_AV_SESSION_TOKEN',
} as const;

export const setAVSessionTokenLoading = createActionWithPayload<
  typeof ACTIONS.SET_AV_SESSION_TOKEN_LOADING,
  { teacherClassroomId: string }
>(ACTIONS.SET_AV_SESSION_TOKEN_LOADING);

export const setAVSessionToken = createActionWithPayload<
  typeof ACTIONS.SET_AV_SESSION_TOKEN,
  {
    teacherClassroomId: string;
    sessionId: undefined | string | Error;
    authToken: undefined | string | Error;
  }
>(ACTIONS.SET_AV_SESSION_TOKEN);

export const resetAVSessionToken = createAction(ACTIONS.RESET_AV_SESSION_TOKEN);
